import {FormattedMessage, IntlShape} from "react-intl"
import {ReactElement} from "react"
import {Icon} from "semantic-ui-react"


interface EventHandlers {
    setContactModalOpen: (open: boolean) => void
}

export const withContactMessage = (
    baseMessage: { id: string },
    intl: IntlShape,
    eventHandlers: EventHandlers
): ReactElement => (
    <span className="with-contact-message">
        {intl.formatMessage(baseMessage)}&nbsp;
        {intl.formatMessage({id: "contact.reach.here"},
        {here: <button className="reach-here" onClick={() => eventHandlers.setContactModalOpen(true)}>
            <span style={{ fontWeight: "bold" }}><FormattedMessage id="contact.reach.here.link"/>&nbsp;<Icon name="mail outline"/></span>
        </button>
        })}
  </span>
)